export default __webpack_public_path__ + "static/map-e24cb69729cc2e08fe263c9fe2d2c47a.svg";